import React, { useState, useEffect } from 'react';
import { getChildWeeklyReport } from '../../services/auth';

interface WeeklyReportPanelProps {
  studentId: string;
}

export const WeeklyReportPanel: React.FC<WeeklyReportPanelProps> = ({ studentId }) => {
  const [report, setReport] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    getChildWeeklyReport(studentId)
      .then(setReport)
      .catch((err) => setError(err.response?.data?.detail || 'Failed to load report'))
      .finally(() => setLoading(false));
  }, [studentId]);

  if (loading) return <div className="panel-loading">Loading weekly report...</div>;
  if (error) return <div className="panel-error">{error}</div>;
  if (!report) return null;

  const { period, this_week, trends, achievements } = report;

  const trendArrow = (value: number, suffix: string = '') => {
    if (value > 0) return <span className="trend-up">+{value}{suffix}</span>;
    if (value < 0) return <span className="trend-down">{value}{suffix}</span>;
    return <span className="trend-flat">0{suffix}</span>;
  };

  return (
    <div className="weekly-report-panel">
      <div className="report-period">{period}</div>

      <div className="report-stats-grid">
        <div className="report-stat">
          <div className="report-stat-value">{this_week.questions_attempted}</div>
          <div className="report-stat-label">Questions</div>
          <div className="report-stat-trend">{trendArrow(trends.questions_change)}</div>
        </div>
        <div className="report-stat">
          <div className="report-stat-value">{this_week.accuracy}%</div>
          <div className="report-stat-label">Accuracy</div>
          <div className="report-stat-trend">{trendArrow(trends.accuracy_change, '%')}</div>
        </div>
        <div className="report-stat">
          <div className="report-stat-value">{this_week.days_practiced}</div>
          <div className="report-stat-label">Days Active</div>
        </div>
        <div className="report-stat">
          <div className="report-stat-value">{this_week.total_minutes}</div>
          <div className="report-stat-label">Minutes</div>
        </div>
      </div>

      {achievements.newly_mastered_count > 0 && (
        <div className="report-achievements">
          <h4>Achievements</h4>
          <p>
            Newly mastered {achievements.newly_mastered_count} learning objective(s):
            {' '}{achievements.newly_mastered_los.join(', ')}
          </p>
        </div>
      )}
    </div>
  );
};
